var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavouriteChecked = function SvgFavouriteChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#FFFFFF59",
    rx: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00333E",
    d: "M19.375 15c-3.797 0-6.875 3.228-6.875 7.21 0 7.21 8.125 13.765 12.5 15.29 4.375-1.525 12.5-8.08 12.5-15.29 0-3.982-3.078-7.21-6.875-7.21-2.325 0-4.381 1.21-5.625 3.064a7 7 0 0 0-2.455-2.254 6.6 6.6 0 0 0-3.17-.81"
  })));
};
export default SvgFavouriteChecked;